import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

import {
  Heading,
  ButtonIconContextual,
  BaseIcon,
  ButtonSecondary,
  SpinnerLoader,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { SideSheet } from '@/modules/common/components/SideSheet';
import {
  NotificationRecord,
  getNotifications,
  postReadNotifications,
  Notification,
  NotificationQueryParams
} from '@/modules/common/services/new-notifications';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationCentral',
  props: {
  isOpen: {
    type: Boolean,
    default: false
  },
  unreadCounter: {
    type: Number,
    default: 0
  }
},
  emits: ['close', 'clearUnread'],
  setup(__props, { emit }) {

const props = __props;

const PAGE_INITIAL = {
  pageIndex: 1,
  pageSize: 15
};

const notificationsData = ref<NotificationRecord[]>([]);
const pagination = ref<NotificationQueryParams>(PAGE_INITIAL);
const isLastPage = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const hasError = ref<boolean>(false);
const isEmpty = ref<boolean>(false);





watch(
  () => props.isOpen,
  async isOpen => {
    if (isOpen) {
      retry();
    }
  }
);

const retry = async () => {
  await fetchNotifications();
  if (!hasError.value && props.unreadCounter > 0) {
    postReadNotifications();
    emit('clearUnread');
  }
};

const fetchNotifications = async () => {
  try {
    isLoading.value = true;
    hasError.value = false;

    const data = await getNotifications(pagination.value);
    notificationsData.value.push(...data.records);
    isLastPage.value = data.pagination.isLastPage;
    isEmpty.value = data.records.length === 0;
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const resetCentral = () => {
  pagination.value = PAGE_INITIAL;
  notificationsData.value = [];
  isLastPage.value = false;
  isLoading.value = false;
  hasError.value = false;
  isEmpty.value = false;
};

const handleClose = () => {
  resetCentral();
  emit('close');
};

const handleClick = (notification: Notification) => {
  if (notification.url) {
    window.open(notification.url, '_self');
  }
};

const computeClass = (notification: Notification) => {
  return {
    'sheet__card-read': notification.read,
    'sheet__card-click': !!notification.url
  };
};

const handleScrollBottom = () => {
  if (
    !isEmpty.value &&
    !isLastPage.value &&
    !isLoading.value &&
    !hasError.value
  ) {
    pagination.value.pageIndex = pagination.value.pageIndex + 1;
    fetchNotifications();
  }
};

return { __sfc: true,PAGE_INITIAL, notificationsData, pagination, isLastPage, isLoading, hasError, isEmpty, emit, props, retry, fetchNotifications, resetCentral, handleClose, handleClick, computeClass, handleScrollBottom, Heading, ButtonIconContextual, BaseIcon, ButtonSecondary, SpinnerLoader, BaseText, NebraskaColors, SideSheet }
}

})